export default __webpack_public_path__ + "static/media/atsignet_dark.3ce46453.png";